/**
 * Created by shinan.chen on 2021/12/25.
 */
import {getCommon, postCommon } from '../tools';
import * as config from '../config';
import { ICard } from './card';

export interface IStudent{
    id:number,
    num:string,
    name:string,
    sex:number,
    phone:string,
    picture:string,
    birthday:Date,
    remark:string,
    storeId:number,
    refStoreIds:number[],
    lastPunchTime:Date,
    teachClassNames:string,
    bindWeChat:boolean,
    bindWechatCode:string,
    invalidCourseCount:number,
    status:string,
    stopTime:Date,
    childrens:ICard[],
}

export interface IStudentDetail{
    id:number,
    num:string,
    name:string,
    sex:number,
    phone:string,
    picture:string,
    birthday:Date,
    remark:string,
    storeId:number,
    lastPunchTime:Date,
    teachClassNames:string,
    bindWeChat:boolean,
    bindWechatCode:string,
    invalidCourseCount:number,
    status:string,
    stopTime:Date,
    childrens:ICard[],

    teachCourses:ITeachCourceInfo[],
    courseInfo:IStudentCourceInfo[],
    cardPunchRecords:ICardPunchRecordInfo[],
}

export interface ITeachCourceInfo{
    teacherName:string,
    classroomName:string,
    storeName:string,
    courseDefinitionName:string,
    teachClassName:string,
    planStartTime:Date,
    costHour:number,
    planStartTimeName:string,
}

export interface IStudentCourceInfo{
    name:string,
    count:number,
    effectiveDate:Date,
}

export interface ICardPunchRecordInfo{
    cardName:string,
    courseName:string,
    studentName:string,
    storeName:string,
    teachClassName:string,
    creationTime:Date,
}

export const getStudent = (id:any) =>
    getCommon({
        url: `${config.SERVICE_URL}/student/get?id=${id}`,
    });

export const listStudents = () =>
    getCommon({
        url: `${config.SERVICE_URL}/student/list_all`,
    });

export const listStudentsByStoreId = (storeId:any) =>
    getCommon({
        url: `${config.SERVICE_URL}/student/list_by_store_id?storeId=${storeId}`,
    });

export const createStudent = (data:IStudent) =>
    postCommon({
        url: `${config.SERVICE_URL}/student/create`,
        data
    });

export const createStudentFull = (data:IStudent) =>
    postCommon({
        url: `${config.SERVICE_URL}/student/create_with_card`,
        data
    });

export const updateStudent = (data:IStudent) =>
    postCommon({
        url: `${config.SERVICE_URL}/student/update`,
        data
    });

    export const stopStudent = (data:IStudent) =>
    postCommon({
        url: `${config.SERVICE_URL}/student/stop?studentId=${data.id}`
    });

    export const resumeStudent = (data:IStudent) =>
    postCommon({
        url: `${config.SERVICE_URL}/student/resume?studentId=${data.id}`
    });

export const deleteStudent = (id:number) =>
    postCommon({
        url: `${config.SERVICE_URL}/student/delete?id=${id}`
    });

export const pageStudents = (pageNum:number,pageSize:number,sexs:any,storeIds:any,teachClassIds:any,keyword:string,courseCountLess:number) =>
    getCommon({
        url: `${config.SERVICE_URL}/student/page?pageNum=${pageNum}&&pageSize=${pageSize}&&sexs=${sexs}&&storeIds=${storeIds}&&teachClassIds=${teachClassIds}&&courseCountLess=${courseCountLess}&&keyword=`+encodeURI(keyword),
    });

export const listFixStudents = (sexs:any,storeIds:any,teachClassIds:any,keyword:string) =>
    getCommon({
        url: `${config.SERVICE_URL}/student/list_fix_students?sexs=${sexs}&&storeIds=${storeIds}&&teachClassIds=${teachClassIds}&&keyword=`+encodeURI(keyword),
    });

    export const listCourseInvalidStudents = (sexs:any,storeIds:any,teachClassIds:any,keyword:string) =>
    getCommon({
        url: `${config.SERVICE_URL}/student/list_course_invalid_students?sexs=${sexs}&&storeIds=${storeIds}&&teachClassIds=${teachClassIds}&&keyword=`+encodeURI(keyword),
    });

export const getStudentForWechat = (code:any) =>
    getCommon({
        url: `${config.HOST}/wechat/get_student_info?code=${code}`,
    });